import { render, staticRenderFns } from "./personalFooter.vue?vue&type=template&id=26478348&scoped=true&"
import script from "./personalFooter.vue?vue&type=script&lang=js&"
export * from "./personalFooter.vue?vue&type=script&lang=js&"
import style0 from "./personalFooter.vue?vue&type=style&index=0&id=26478348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26478348",
  null
  
)

export default component.exports